import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/lib/auth";
import Layout from "@/components/Layout";
import Protected from "@/components/Protected";

import Landing from "@/pages/Landing";
import HowItWorks from "@/pages/HowItWorks";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import Quiz from "@/pages/Quiz";
import Score from "@/pages/Score";
import Report from "@/pages/Report";
import Resources from "@/pages/Resources";
import Books from "@/pages/Books";
import AllResources from "@/pages/AllResources";
import ResourceDetail from "@/pages/ResourceDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminResources from "@/pages/admin/AdminResources";
import AdminQuestions from "@/pages/admin/AdminQuestions";
import AdminBooks from "@/pages/admin/AdminBooks";
import AdminSubmission from "@/pages/admin/AdminSubmission";
import MyPanel from "@/pages/MyPanel";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster theme="dark" position="top-center" />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/nasil-calisir" element={<HowItWorks />} />
            <Route path="/kayit" element={<Register />} />
            <Route path="/giris" element={<Login />} />

            <Route path="/test" element={<Protected><Quiz /></Protected>} />
            <Route path="/panelim" element={<Protected><MyPanel /></Protected>} />
            <Route path="/skor" element={<Protected><Score /></Protected>} />
            <Route path="/rapor" element={<Protected><Report /></Protected>} />
            <Route path="/oneriler" element={<Protected><Resources /></Protected>} />
            <Route path="/kitaplar" element={<Protected><Books /></Protected>} />
            <Route path="/kaynaklar" element={<Protected><AllResources /></Protected>} />
            <Route path="/kaynaklar/:id" element={<Protected><ResourceDetail /></Protected>} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/resources" element={<AdminResources />} />
            <Route path="/admin/questions" element={<AdminQuestions />} />
            <Route path="/admin/books" element={<AdminBooks />} />
            <Route path="/admin/submissions/:id" element={<AdminSubmission />} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
